export function getStore(key) {
  let value = localStorage.getItem(key)
  if (value)
      return JSON.parse(value)
  return undefined
}
export function setStore(key, value) {
  localStorage.setItem(key, JSON.stringify(value))
}

export function removeStore(key) {
  localStorage.removeItem(key)
}

export function clearStore() {
  localStorage.clear();
}

export const keys = {
  token: 'token',
  lang: 'lang',
  user: 'user',
  userInfo: 'userinfo',
  IntercomUser:'IntercomUser',
  userProfile:'UserProfile',
  searchFilter:'SearchFilter',
  Order_information:'Order_information',
  currentCourse:'currentCourse',
  userBalance:'userBalance',
  areaCodeList:'areaCodeList',
  status:'status',
}


// WEBPACK FOOTER //
// ./src/store/index.js